import is from '@sindresorhus/is';

export type SingleSelectProps<T> = {
    readonly isMultiSelect?: false;
    readonly onValueChange?: (value: T | undefined) => void;
    readonly value?: T;
};

export type MultiSelectProps<T> = {
    readonly isMultiSelect: true;
    readonly onValueChange?: (values: readonly T[]) => void;
    readonly value?: readonly T[];
};

export type SelectProps<T> = MultiSelectProps<T> | SingleSelectProps<T>;

export const isSingleSelect = <T extends string>(props: SelectProps<T>): props is SingleSelectProps<T> => {
    return props.isMultiSelect !== true;
};

export const handleSelect = <T extends string>(props: SelectProps<T>, selectedValue: T): void => {
    if (isSingleSelect(props)) {
        const newValue = selectedValue === props.value ? undefined : selectedValue;
        props.onValueChange?.(newValue);
    } else {
        const currentValue = is.undefined(props.value) ? [] : props.value;
        const newValue = currentValue.includes(selectedValue)
            ? currentValue.filter((v: T) => v !== selectedValue)
            : [...currentValue, selectedValue];
        props.onValueChange?.(newValue);
    }
};
